export default __webpack_public_path__ + "static/media/Poppins.44ee7912.woff";